{
  "language": "Language",
  "confirm_default_title": "Are you sure?",
  "actions": {
    "confirm": "Confirm",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved ✓",
    "delete": "Delete",
    "deleting": "Deleting…",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "continue": "Continue",
    "retry": "Retry",
    "ok": "OK, got it",
    "create": "Create",
    "invite": "Invite",
    "search": "Search",
    "open": "Open",
    "show": "Show",
    "hide": "Hide"
  },
  "states": {
    "empty": "Nothing here yet.",
    "no_results": "No results.",
    "loading": "Loading…",
    "error": "Something went wrong."
  },
  "offline": "Offline — some actions are disabled",
  "toast_region": "Notifications",
  "toast_close": "Dismiss notification",
  "cookies": {
    "message": "We use cookies and tools like PostHog (anonymous analytics) and Sentry (error reports) to improve Tworks.",
    "policy_link": "View privacy policy",
    "accept": "OK, got it",
    "close_label": "Dismiss cookie notice",
    "region_label": "Cookie notice"
  },
  "google_play": {
    "cta": "Get it on Google Play"
  },
  "pwa": {
    "title": "Install Tworks",
    "android_title": "Tworks for Android",
    "android_description": "It's live on Google Play: push notifications and meeting recording from your phone.",
    "description": "Quick access from your home screen. Works offline for the basics.",
    "install": "Install",
    "installing": "Installing…",
    "later": "Not now",
    "ios_description": "On iPhone and iPad you install it from Safari's share menu:",
    "ios_step_share": "Tap the Share button",
    "ios_step_add": "Choose “Add to Home Screen”",
    "got_it": "Got it"
  },
  "teams": {
    "config": {
      "title": "Tworks",
      "body": "Tworks will appear in this tab. Click “Save” to add it to the channel."
    }
  },
  "common": {
    "stop_timer": "Stop timer"
  },
  "share": {
    "copied": "Link copied to clipboard",
    "failed": "Couldn't copy the link"
  }
}
